import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { CardText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { transparencyColors } from '@Components/BigBrowse/GridCardMesh/gridCardConstants';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { Assets } from '@Utils/AssetsStore';
import { observer } from 'mobx-react-lite';

import type { GridCardMeshProps } from '../GridCardMesh2';
import { ProductCardRounded } from '../primitives/ProductCardRounded';

export const BigBrowseBookend = observer(function BigBrowseBookend({
  item,
  onClick,
}: GridCardMeshProps<PlaneTypes.Card_BigBrowse_Bookend>) {
  const titleProps: CardTextProps = {
    text: item.data?.title ?? '',
    fontAsset: Assets.Font_Gilroy_Bold,
    fontSize: 24,
    color: 'white',
    anchorX: 'center',
    anchorY: 'middle',
    textAlign: 'center',
    maxWidth: item.size.width - 100,
  };

  return (
    <ProductCardRounded
      position={item.worldPosition}
      size={item.size.width}
      imageUrl={item.data?.imageUrl}
      transparencyColor={transparencyColors[item.type]}
      onClick={onClick}
      uniqueKey={item.key!}
    >
      <CardText {...titleProps} />
    </ProductCardRounded>
  );
});
